export interface Quest {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    userId: string;
    title: string;
    desc: string;
    dateStarted: string;
    dateFinished: string;
    intendedEndDate: string;
    difficulty: number;
    objectives: Array<Objective>;
    battles: Array<Battle>;
    notification: QuestNotification;
}

export interface Objective {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    title: string;
    type: number;
    goal: number;
    value: number;
}

export interface Battle {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    desc: string;
    dateOf: string;
    status: number;
}

export interface QuestNotification {
    reminder: NotificationConfig;
    prompt: NotificationConfig;
    daysLeft: NotificationConfig;
}

export interface NotificationConfig {
    active: boolean;
    timestamp: string;
    freq: number;
}

export const NOTI_FREQ = {
    DAILY: 0,
    WEEKLY: 1,
    MONTHLY: 2,
};

export const QUEST_DIFFICULTY = {
    GRAY: 0,
    GREEN: 1,
    YELLOW: 2,
    ORANGE: 3,
    RED: 4,
};

export const QUEST_DIFFICULTY_NAME = {
    [QUEST_DIFFICULTY.GRAY]: "GRAY",
    [QUEST_DIFFICULTY.GREEN]: "GREEN",
    [QUEST_DIFFICULTY.YELLOW]: "YELLOW",
    [QUEST_DIFFICULTY.ORANGE]: "ORANGE",
    [QUEST_DIFFICULTY.RED]: "RED",
};

export const OBJECTIVE_TYPE = {
    COUNT: 0,
    FACT: 1,
};

export const BATTLE_STATUS = {
    DEFEAT: 0,
    VICTORY: 1,
    ONGOING: 2,
};

export const BATTLE_STATUS_NAME = {
    [BATTLE_STATUS.DEFEAT]: "Defeat",
    [BATTLE_STATUS.VICTORY]: "Victory",
    [BATTLE_STATUS.ONGOING]: "Ongoing",
};

export interface UpdateQuest {
    title?: string;
    desc?: string;
    dateStarted?: string;
    dateFinished?: string;
    intendedEndDate?: string;
    difficulty?: number;
}
